import {NavigationDataEntry} from "../data";
import React from "react";
import {MarkdownContent} from "../MarkdownContent";
import {ScrollUtil} from "../util/ScrollUtil";
import {HashLink as Link} from "react-router-hash-link";

export type ContentPageProps = {
    pageId: string,
    entries: NavigationDataEntry[]
}

export const ContentPage: React.FC<ContentPageProps> = ({pageId, entries}) => {
    return (
        <div id={pageId} className="page">
            {entries.map((entry) => (
                <>
                    <h2 id={entry.anchor}>{entry.name}</h2>
                    <MarkdownContent file={entry.file} onContentLoaded={ScrollUtil.scrollToHashElement}/>
                    {entry.registrationLink && <Link to='/termine_anmeldung'>Termine/Anmeldung</Link>}
                </>
            ))}
        </div>
    );
}
